require('team-admin')
angular.module('team-admin').filter('jerseyNumber', function() {
  return function(str) {
    return str == parseInt(str) ? '#' + str : str
  }
})
